import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DepartmentModal } from '@/modules/admin-dashboard/components/modals/DepartmentModal.tsx';
import { useCreateDepartmentMutation } from '@/modules/admin-dashboard/queries/department.ts';
import { useUsersListQuery } from '@/modules/admin-dashboard/queries/users.ts';
import { BaseModalProps } from 'ui';
import { useDebounce } from 'ui/hooks';
import { CreateDepartmentResponse } from 'compliance-api';

const initialValues: { name: string; userIds: number[] } = {
  name: '',
  userIds: [],
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Department name is required'),
  userIds: Yup.array().of(Yup.number()),
});

interface CreateDepartmentModalProps extends BaseModalProps {
  onSuccess?: (response: CreateDepartmentResponse) => void;
}

export const CreateDepartmentModal = ({ open, onClose, onSuccess }: CreateDepartmentModalProps) => {
  const handleCloseModal = () => {
    formik.resetForm();
    onClose();
  };

  const [filterByName, setFilterByName] = useDebounce('', 500);

  const {
    hasNextPage,
    fetchNextPage,
    data: users,
    isLoading,
  } = useUsersListQuery({
    page: 1,
    page_size: 15,
    filter_by_name: filterByName,
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: false,
    validateOnMount: false,
    validateOnBlur: false,
    onSubmit: async values => {
      const res = await mutateAsync({
        user_ids: values.userIds,
        name: values.name,
      });
      onSuccess && onSuccess(res);
      handleCloseModal();
    },
  });

  const { mutateAsync, isLoading: isSaving } = useCreateDepartmentMutation({
    setErrors: formik.setErrors,
  });
  return (
    <DepartmentModal
      isOpened={open}
      handleCloseModal={handleCloseModal}
      handleSearchChange={setFilterByName}
      fetchNextPage={fetchNextPage}
      formik={formik}
      hasNextPage={!!hasNextPage}
      users={users}
      isLoading={isLoading}
      isSaving={isSaving}
    />
  );
};
